import { getCurrentUser } from "aws-amplify/auth";
import { getTokenFromLocalStorage } from "../../utils/getTokenFromLocalStorage";
import ErrorHandler from "./ErrorHandler";

export class AuthService {
  private apiToken: string | null = null;
  private tokenPromise: Promise<string | null> | null = null;

  constructor(private clientId: string) {}

  async getToken(): Promise<string | null> {
    if (this.apiToken !== null) {
      return this.apiToken;
    }

    if (!this.tokenPromise) {
      this.tokenPromise = this.fetchToken();
    }

    return this.tokenPromise;
  }

  private async fetchToken(): Promise<string | null> {
    try {
      const { username, userId } = await getCurrentUser();
      if (username && userId) {
        const tokenKey = `CognitoIdentityServiceProvider.${this.clientId}.${username}.accessToken`;
        this.apiToken = getTokenFromLocalStorage(tokenKey, username, "accessToken");
      }
      return this.apiToken;
    } catch (error) {
      throw ErrorHandler.logError(new Error(`Authentification failed: ${error}`));
    }
  }
}